var _path, _rect, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,9.25A2.7528,2.7528,0,0,0,23.25,12V68A2.7528,2.7528,0,0,0,26,70.75H54A2.7528,2.7528,0,0,0,56.75,68V12A2.7528,2.7528,0,0,0,54,9.25ZM55.25,12V68A1.25116,1.25116,0,0,1,54,69.25H26A1.25116,1.25116,0,0,1,24.75,68V12A1.25116,1.25116,0,0,1,26,10.75H54A1.25116,1.25116,0,0,1,55.25,12Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 15.25,
    width: 8,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,59.25A2.75,2.75,0,1,0,42.75,62,2.7528,2.7528,0,0,0,40,59.25Zm0,4A1.25,1.25,0,1,1,41.25,62,1.25116,1.25116,0,0,1,40,63.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.36914,36.8252l1.06055,1.06054a10.706,10.706,0,0,1,15.14062,0l1.06055-1.06054a12.20544,12.20544,0,0,0-17.26172,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.06934,39.52539l1.06054,1.06055a6.88782,6.88782,0,0,1,9.74024,0l1.06054-1.06055a8.38727,8.38727,0,0,0-11.86132,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.76953,42.22559l1.06055,1.06054a3.14267,3.14267,0,0,1,4.33984,0l1.06055-1.06054a4.56791,4.56791,0,0,0-6.46094,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 46,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.37bf2bbbf9977af944b9aa745e78f063.svg";
export { ForwardRef as ReactComponent };